import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../Assessts/Styles/SamagraDashboard/Sidemenu.scss";
const SamagraMenu = () => {
  const navigate = useNavigate();
  const [MSelection, SetMSelection] = useState("Student Participation");
  const menuItems = [
    {
      name: "Student Participation",
      icon: "✅",
    },
    {
      name: "Performance Overview",
      icon: "📊",
    },
    {
      name: "Curriculum Analysis",
      icon: "📖",
    },
    {
      name: "Student Directory",
      icon: "👥",
    },
    // {
    //   name: "Student Report Card",
    //   icon: "📋",
    // },
    {
      name: "Question Papers",
      icon: "📝",
    },
  ];
  const SNavigation = (e) => {
    switch (e) {
      case 0: navigate("/Principle/SamagraDashboard/Participation");
        break;
      case 1: navigate("/Principle/SamagraDashboard/Performance");
        break;
      case 2: navigate("/Principle/SamagraDashboard/CircularAnalysis");
        break;
      case 3: navigate("/Principle/SamagraDashboard/Directory");
        break;
      case 4: navigate("/Principle/SamagraDashboard/SAMAGRAStudent");
        break;
    }
  }
  return (<>

    <div className="Ssidebar">
      {menuItems.map((item, index) => (
        <div
          key={index} onClick={() => { SetMSelection(item.name); SNavigation(index) }}
          className={`menu-item ${item.name === MSelection ? "active" : ""}`}
        >
          <span className="icon">{item.icon}</span>
          <span className="text">{item.name}</span>
        </div>
      ))}
    </div>

  </>)
}
export default SamagraMenu;